<template>
  <content-activity :value="itemRevision" />
</template>
<script>
import ContentActivity from "./index.vue"
import { mapState, mapActions } from "vuex"
import { STORE_CONTENT_NAME, STATE_ITEM_REVISION, ACTION_LOAD_DRAFT } from "@/store_constants/content"
export default {
  name: "DraftPreviewActivity",
  props: ["id"],
  components: { ContentActivity },
  data() {
    return {}
  },
  computed: {
    ...mapState(STORE_CONTENT_NAME, {
      itemRevision: STATE_ITEM_REVISION
    })
  },
  methods: {
    ...mapActions(STORE_CONTENT_NAME, [ACTION_LOAD_DRAFT])
  },
  created() {
    this[ACTION_LOAD_DRAFT]({ item_id: this.id, mode: "activity" })
  }
}
</script>
<style scoped>
</style>